import {
	AuthenticatedUser,
	UserFormValues,
	UserServiceInterface,
	User,
	APIClientInterface,
	ListResponse,
	SingleResponse,
	UserListItem,
	UserUpdateFormValues,
	LogoutResponse,
	UserSelfUpdateFormValues,
	ApiToken,
	ApiTokenCreateFormValues
} from '../types'

export default class UsersService implements UserServiceInterface {
	constructor(private client: APIClientInterface) { }

	public getAll(): Promise<ListResponse<UserListItem>> {
		return this.client.get(`/users`)
	}

	public getTokens(): Promise<ListResponse<ApiToken>> {
		return this.client.get('/api-tokens')
	}

	public createToken(values: ApiTokenCreateFormValues): Promise<SingleResponse<string>> {
		return this.client.post('/api-tokens', JSON.stringify(values))
	}

	public deleteToken(id: number): Promise<void> {
		return this.client.delete(`/api-tokens/${id}`)
	}

	public create(values: UserFormValues): Promise<SingleResponse<User>> {
		return this.client.post(`/users`, JSON.stringify(values))
	}

	public update(id: number, values: UserUpdateFormValues): Promise<SingleResponse<User>> {
		return this.client.patch(`/users/${id}`, JSON.stringify(values))
	}

	public updateSelf(id: number, values: UserSelfUpdateFormValues): Promise<void> {
		return this.client.patch(`/users/self`, JSON.stringify(values))
	}

	public delete(id: number): Promise<void> {
		return this.client.delete(`/users/${id}`)
	}

	public getSelf(): Promise<SingleResponse<AuthenticatedUser>> {
		return this.client.get('/users/self')
	}

	public logout(): Promise<SingleResponse<LogoutResponse>> {
		return this.client.post(`/logout`, '')
	}

	public loginUrl(state: string): string {
		const base = process.env.REACT_APP_API_URL || 'https://licensing-portal-api.mondago.com'
		return `${base}/login/b2c?state=${state}`
	}
}
